// extracted by mini-css-extract-plugin
export default {"backdrop":"K8AA1k","dialog":"LdpWDM","header":"ANlyQr","title":"oNA91M","closeButton":"QYLl7J","message":"nbroKm","footer":"coNbrJ","confirmButton":"bXBp9d"};